import { getToken, getMessaging, onMessage, isSupported } from 'firebase/messaging'
import { app, auth } from '@/firebase/firebaseConfig'
import api from '@/services/api'

const VAPID_KEY = process.env.VUE_APP_FIREBASE_VAPID_KEY

export function useFCM() {
  async function registrar() {
    try {
      if (!('Notification' in window)) return
      if (!auth?.currentUser) return
      if (!VAPID_KEY) return

      const supported = await isSupported()
      if (!supported) return

      const permission = await Notification.requestPermission()
      if (permission !== 'granted') return

      await navigator.serviceWorker.register('/firebase-messaging-sw.js')

      const messaging = getMessaging(app)
      const token = await getToken(messaging, { vapidKey: VAPID_KEY })
      if (!token) return

      await api.patch(`/users/${auth.currentUser.uid}/fcm-token`, { token })
    } catch {
      // não crítico — push é opcional
    }
  }

  function ouvirForeground(callback) {
    isSupported().then(supported => {
      if (!supported || !app) return
      try {
        onMessage(getMessaging(app), callback)
      } catch { /* foreground listener opcional */ }
    })
  }

  return { registrar, ouvirForeground }
}
